(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("CloserSDK", [], factory);
	else if(typeof exports === 'object')
		exports["CloserSDK"] = factory();
	else
		root["CloserSDK"] = factory();
})(window, function() {
return 